function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M22 16C21.4477 16 21 16.4477 21 17V21H17C16.4477 21 16 21.4477 16 22C16 22.5523 16.4477 23 17 23H21V27C21 27.5523 21.4477 28 22 28C22.5523 28 23 27.5523 23 27V23H27C27.5523 23 28 22.5523 28 22C28 21.4477 27.5523 21 27 21H23V17C23 16.4477 22.5523 16 22 16Z",
  fill: "#BBC1C7"
});
var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 7,
  y: 7,
  width: 30,
  height: 30,
  rx: 7,
  stroke: "#BCC3D0",
  strokeOpacity: 0.5,
  strokeWidth: 2,
  strokeMiterlimit: 16,
  strokeDasharray: "5 5"
});
const SvgAddFile = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 44,
  height: 44,
  viewBox: "0 0 44 44",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2);
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAddFile, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/add-file.4ab33a66.svg";
export { ForwardRef as ReactComponent };